
export enum AppMode {
  CHAT = 'CHAT',
  LIVE = 'LIVE',
  VISUAL_STUDIO = 'VISUAL_STUDIO',
  PERSONA_ENGINE = 'PERSONA_ENGINE',
  KEY_MANAGEMENT = 'KEY_MANAGEMENT',
  ABOUT = 'ABOUT',
  BILLING = 'BILLING',
  GALLERY = 'GALLERY',
  SAFE_HARBOR = 'SAFE_HARBOR',
  SYNC_CENTER = 'SYNC_CENTER'
}

export type AIProvider = 'google' | 'openai' | 'anthropic';

export interface ModelOption {
  id: string;
  provider: AIProvider;
  name: string;
  description: string;
}

export type SubscriptionTier = 'Free' | 'StudioPass' | 'Enterprise';

export interface UserProfile {
  name: string;
  birthdayDay: string;
  birthdayMonth: string;
  city: string;
  region: string;
  country: string;
  language: string; 
  siteLanguage?: string;
  accent: string;
  avatar?: string;
  credits?: number;
  subscriptionTier: SubscriptionTier;
  subscriptionId?: string;
}

export interface AIPersona {
  id: string;
  name: string;
  gender: string;
  language: string;
  accent: string;
  background: string;
  traits: string[];
  interests: string[];
  style: string;
  avatar?: string;
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'model';
  text: string;
  timestamp: Date;
  isError?: boolean;
  imageUrl?: string;
  videoUrl?: string;
}

export interface StudioImage {
  id: string;
  url: string;
  prompt: string;
  timestamp: Date;
  personaId: string;
}

// Fix: Changed from interface to enum to support both type and value usage in the application
export enum ConnectionStatus {
  DISCONNECTED = 'DISCONNECTED',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
}
